enum ENUM_PROJECT_STATUS {
  DONE = "done",
  REJECTED = "rejected",
  REJECTED_BY_CLIENT = "rejected_by_client",
  REJECTED_BY_AMBASSADOR = "rejected_by_ambassador",
  CREATED = "created",
  REQUESTED = "requested",
  AWAITING_FOR_RESPONSE = "awaiting_for_response",
  RESPONDED = "responded",
  ADDED_TIME_SLOTS_BY_CLIENT = "added_time_slots_by_client",
  AWAITING_FOR_TIME_SLOT = "awaiting_for_time_slot",
  SELECTED_TIME_SLOT_BY_AMBASSADOR = "selected_time_slot_by_ambassador",
  SUGGESTED_TIME_SLOT_BY_AMBASSADOR = "suggested_time_slots_by_ambassador",
  AWAITING_FOR_TIME_SLOT_SELECTION = "awaiting_for_time_slot_selection",
  SEND_MEETING_LINK = "send_meeting_link",
  UPDATE_INVITATION = "update_invitation",
  CANCELED_BY_CLIENT = "canceled_by_client",
  CANCELED_BY_AMBASSADOR = "canceled_by_ambassador",
  APPROVED_BY_CLIENT = "approved_by_client",
  ARCHIVE = "archive",
  DONE_BY_AMBASSADOR = "done_by_ambassador",
  DONE_BY_CLIENT = "done_by_client",
  UNAVAILABLE_TIME_SLOT_BY_CLIENT = "unavailable_time_slot_by_client",
  UNAVAILABLE_TIME_SLOT_BY_AMBASSADOR = "unavailable_time_slot_by_ambassador",
  CONFIRMED_ATTENDANCE_BY_AMBASSADOR = "confirmed_attendance_by_ambassador",
  VENDOR_RESCHEDULE_REQUESTED = "vendor_reschedule_requested",
  AMBASSADOR_RESCHEDULE_REQUESTED = "ambassador_reschedule_requested",
}

enum ENUM_PROJECT_STATUS_CATEGORY {
  NEW = "new",
  SCHEDULING = "scheduling",
  UPCOMING = "upcoming",
  PAST = "past",
  ALL = "all",
}

enum ENUM_MEETING_STATUS {
  APPROVED = "approved",
  PENDING = "pending",
  REJECTED = "rejected",
  DONE = "done",
}

enum ENUM_PROJECT_ARCHIVE_REASON {
  CANCELLED = "cancelled",
  RE_SCHEDULE = "re_schedule",
}

enum ENUM_RESCHEDULE_REASON_TYPE {
  SCHEDULING_CONFLICT = "scheduling_conflict",
  EMERGENCY = "emergency",
  AVAILABILITY_CHANGED = "availability_changed",
  TECHNICAL_ISSUE = "technical_issue",
  OTHER = "other",
}

export {
  ENUM_PROJECT_STATUS,
  ENUM_MEETING_STATUS,
  ENUM_PROJECT_ARCHIVE_REASON,
  ENUM_PROJECT_STATUS_CATEGORY,
  ENUM_RESCHEDULE_REASON_TYPE,
};
